import styled, { css } from 'styled-components/macro';

export const AiBlockWrapper = styled.div`
  ${({ theme }) => css`
    padding: ${theme.spacings.s};
    display: flex;
    flex-direction: column;
    gap: ${theme.spacings.xs};
    background-color: ${theme.colors.white};
    border-radius: ${theme.radiuses.s};

    ${theme.fonts['body-14'].css};
  `}
`;

export const LoadingWrapper = styled.div<{ $loading: boolean }>`
  ${({ theme, $loading }) => css`
    position: relative;
    transition-duration: ${theme.tokens.animation.duration.base};

    ${$loading &&
    css`
      margin: -${theme.spacings.xxs};
      padding: ${theme.spacings.xxs};
      border-radius: ${theme.radiuses.xs};
      background-color: ${theme.colors.gray[100]};
      pointer-events: none;
    `}
  `}
`;
